import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import InventoryHistoryDetailModal from 'src/atomic-components/organisms/Modals/InventoryDetailModal';
import InventoryBoard from 'src/atomic-components/templates/PageBoard/InventoryBoard';
import InventoryInboundHistoryBoard from 'src/atomic-components/templates/PageBoard/InventoryInboundHistoryBoard';
import InventoryIssueBoard from 'src/atomic-components/templates/PageBoard/InventoryIssueBoard';
import InventoryOutboundHistoryBoard from 'src/atomic-components/templates/PageBoard/InventoryOutboundHistoryBoard';
import InventorySettingsBoard from 'src/atomic-components/templates/PageBoard/InventorySettingsBoard';
import InventorySupplierInboundBoard from 'src/atomic-components/templates/PageBoard/InventorySupplierInboundBoard/InventorySupplierInboundBoard';
import InventorySupplierInboundListBoard from 'src/atomic-components/templates/PageBoard/InventorySupplierInboundBoard/InventorySupplierInboundListBoard';
import ProductSupplierBoard from 'src/atomic-components/templates/PageBoard/ProductSupplierBoard';

const InventoryPage: FC = () => {
  return (
    <>
      <InventoryHistoryDetailModal />
      <Routes>
        <Route path='/settings/:inventoryId' element={<InventorySettingsBoard />} />
        <Route path='/settings' element={<InventorySettingsBoard />} />
        <Route path='/list' element={<InventoryBoard />} />
        <Route path='/supplier' element={<ProductSupplierBoard />} />
        <Route path='/supplier-inbound/:productSupplierId' element={<InventorySupplierInboundBoard />} />
        <Route path='/supplier-inbound' element={<InventorySupplierInboundBoard />} />
        <Route path='/supplier-inbound-list/:supplierReceiptId' element={<InventorySupplierInboundListBoard />} />
        <Route path='/supplier-inbound-list' element={<InventorySupplierInboundListBoard />} />
        <Route path='/inventory-issue' element={<InventoryIssueBoard />} />
        {/* 입고 요청 내역 - 탭: 전체 입고, 거래처, 재고 이슈, 매장 이슈 */}
        <Route path='/inbound-history' element={<InventoryInboundHistoryBoard />} />
        {/* 출고 요청 내역 - 탭: 전체 출고, 주문, 재고 이슈, 매장 이슈 */}
        <Route path='/outbound-history' element={<InventoryOutboundHistoryBoard />} />
        {/* 개별 재고 입출고 내역 모달 */}
        {/* 선택적 재고 이슈 모달 */}
        <Route path='/' element={<Navigate to='./settings' replace />} />
      </Routes>
    </>
  );
};

export default InventoryPage;
